<template>
    <div v-if="variant" class="main-container">
        <div class="main-content">
            <StatusIndicator>
                <template #icon>
                    <PhWarningCircle :size="20" class="text-amber-400" />
                </template>
            </StatusIndicator>
            <div class="content">
                <!-- No license -->
                <div class="upper" v-if="variant === 'unlicensed'">
                    <div class="title">
                        <span>Let us handle it!</span>
                    </div>
                    <p>Get full automation and nonstop scanning across {{ formattedBrokerCount }} brokers! Subscribe now.</p>
                </div>
                <!-- Essentials license -->
                <div class="upper" v-else-if="variant === 'upgrade'">
                    <div class="title">
                        <span>Unlock this feature</span>
                    </div>
                    <p>Upgrade to add automated handling and always-on scanning across {{ formattedBrokerCount }} brokers.</p>
                </div>
                <!-- Other licenses, and only over an exposure we are actually handling -->
                <div class="upper" v-else>
                    <div class="title">
                        <span>We're on it!</span>
                    </div>
                    <p>Your license already handles this automatically! This is just info for non-licensed users.</p>
                </div>
            </div>
        </div>
        <PrimeButton
            v-if="variant !== 'automated'"
            @click="openFeatureModal('Automated Company Deletion')"
            :label="buttonLabel"
            class="w-full mt-4"
        />
    </div>
</template>
<script setup lang="ts">
import StatusIndicator from '~/components/main/shared/StatusIndicator.vue';
import { useAuthStore } from '~/stores/auth';
import { getDeletionGuideAlertVariant } from './deletionGuideAlertVariant';

interface Props {
    /** Whether the drawer is showing a tracked exposure rather than a company on its own. */
    hasExposure: boolean;
}

const props = defineProps<Props>();

// The coverage figure this copy sells is the live one, exact. It reads from the
// same source every other surface reads, so the number a member is shown here
// and in the licence benefits can never disagree.
const { formattedBrokerCount } = useBrokerStats();

const authStore = useAuthStore();

const { openFeatureModal } = useFeatureLockedModal();

const variant = computed(() => getDeletionGuideAlertVariant({
    licenseName: authStore.user?.license?.name,
    hasExposure: props.hasExposure,
}));

const buttonLabel = computed(() => (variant.value === 'upgrade' ? 'Upgrade License' : 'Protect Yourself'));
</script>
<style lang="scss" scoped>
.main-container {
    @apply flex-col py-4 pr-4 pl-6 border-b border-zinc-300;
}
.main-content {
    @apply flex gap-4;
}
.content {
    @apply flex flex-col items-start gap-3 flex-1;
}
.upper {
    @apply flex flex-col gap-0.5 items-start flex-1 w-full;

    p {
        @apply text-zinc-700 text-sm font-normal leading-5;
    }
}
.title {
    @apply flex justify-between items-center w-full;

    span {
        @apply text-zinc-950 text-sm font-semibold leading-5;
    }
}
.dont-show {
    @apply text-zinc-600 text-sm font-semibold leading-5;
}
</style>
